
<mat-card>
    <mat-card-header>
        <mat-card-title>Lista articoli</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <mat-tab-group color="primary" [(selectedIndex)]="tabIndex" (focusChange)="myTabFocusChange($event)">
        <mat-tab label="{{tab.name}}" *ngFor="let tab of tabs">
          <ng-template matTabContent>
             <app-articolitabs [tab]="tab.id"></app-articolitabs>
          </ng-template>         
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
    <mat-card-actions>

    </mat-card-actions>

</mat-card>
<!--
<div [class]="tab" *ngIf="tab == 'tabOne'">
      <mat-card>
          <mat-card-header>
              <mat-card-title>Lista articoli</mat-card-title>
          </mat-card-header>
          <mat-card-content>


      <mat-form-field style="padding-right:10px">
         <mat-label class="text-sm">Codice articolo</mat-label>
         <input matInput [(ngModel)]="filtroCodicearticolo" name="filtroCodicearticolo" (keyup)="onFiltroCodicearticoloKeyup($event)" class="text-sm">
      </mat-form-field>

      <mat-form-field style="padding-right:10px">
         <mat-label class="text-sm">Descrizione</mat-label>
         <input matInput [(ngModel)]="filtroDescrizione" name="filtroDescrizione" (keyup)="onFiltroDescrizioneKeyup($event)" class="text-sm">
      </mat-form-field>

      <mat-form-field style="padding-right:10px">
         <mat-label class="text-sm">Giacenza > o = di</mat-label>
         <input matInput #fgte name="filtroGte" (keyup)="onFiltroGteKeyup($event)" class="text-sm">
      </mat-form-field>

      <mat-form-field style="padding-right:10px">
         <mat-label class="text-sm">Giacenza < o = di</mat-label>
         <input matInput #flte name="filtroLte" (keyup)="onFiltroLteKeyup($event)" class="text-sm">
      </mat-form-field>

      <button mat-raised-button  color="primary" (click)="cerca()">Cerca</button>

        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

          <ng-container matColumnDef="Id">
              <th [style.display]="getConfigurazione().Id" mat-header-cell *matHeaderCellDef>Id
                <img src="./assets/images/sort.png" (click)="manageClick('Id')"/>
              </th>
              <td [style.display]="getConfigurazione().Id" mat-cell *matCellDef="let articolo"> {{articolo.Id}} </td>
          </ng-container>

          <ng-container matColumnDef="Catalogo">
              <th [style.display]="getConfigurazione().Catalogo" mat-header-cell *matHeaderCellDef>Catalogo
                <img src="./assets/images/sort.png" (click)="manageClick('Catalogo')"/>
              </th>
              <td [style.display]="getConfigurazione().Catalogo" mat-cell *matCellDef="let articolo"> {{articolo.Catalogo.Nome}} </td>
          </ng-container>

          <ng-container matColumnDef="Codicecatalogo">
              <th [style.display]="getConfigurazione().Codicecatalogo" mat-header-cell *matHeaderCellDef>Codicecatalogo
                <img src="./assets/images/sort.png" (click)="manageClick('Codicecatalogo')"/>
              </th>
              <td [style.display]="getConfigurazione().Codicecatalogo" mat-cell *matCellDef="let articolo"> {{articolo.Codicecatalogo}} </td>
          </ng-container>

          <ng-container matColumnDef="Codicearticolo">
              <th [style.display]="getConfigurazione().Codicearticolo" mat-header-cell *matHeaderCellDef>Codice articolo
                <img src="./assets/images/sort.png" (click)="manageClick('Codicearticolo')"/>
              </th>
              <td [style.display]="getConfigurazione().Codicearticolo" mat-cell *matCellDef="let articolo"> {{articolo.Codicearticolo}} </td>
          </ng-container>

          <ng-container matColumnDef="Descrizione">
              <th [style.display]="getConfigurazione().Descrizione" mat-header-cell *matHeaderCellDef>Descrizione
                <img src="./assets/images/sort.png" (click)="manageClick('Descrizione')"/>
              </th>
              <td [style.display]="getConfigurazione().Descrizione" mat-cell *matCellDef="let articolo"> {{articolo.Descrizione}} </td>
          </ng-container>

          <ng-container matColumnDef="Categoria">
              <th [style.display]="getConfigurazione().Categoria" mat-header-cell *matHeaderCellDef>Categoria
                <img src="./assets/images/sort.png" (click)="manageClick('Categoria')"/>
              </th>
              <td [style.display]="getConfigurazione().Categoria" mat-cell *matCellDef="let articolo"> {{articolo.Categoria}} </td>
          </ng-container>

          <ng-container matColumnDef="Costo">
              <th [style.display]="getConfigurazione().Costo" mat-header-cell *matHeaderCellDef>Costo
                <img src="./assets/images/sort.png" (click)="manageClick('Costo')"/>
              </th>
              <td [style.display]="getConfigurazione().Costo" mat-cell *matCellDef="let articolo"> {{articolo.Costo | number: '1.2-2' }} </td>
          </ng-container>

          <ng-container matColumnDef="Iva">
              <th [style.display]="getConfigurazione().Iva" mat-header-cell *matHeaderCellDef>IVA %
                <img src="./assets/images/sort.png" (click)="manageClick('Iva')"/>
              </th>
              <td [style.display]="getConfigurazione().Iva" mat-cell *matCellDef="let articolo"> {{articolo.Iva}} </td>
          </ng-container>

          <ng-container matColumnDef="Prezzo">
              <th [style.display]="getConfigurazione().Prezzo" mat-header-cell *matHeaderCellDef>Prezzo
                <img src="./assets/images/sort.png" (click)="manageClick('Prezzo')"/>
              </th>
              <td [style.display]="getConfigurazione().Prezzo" mat-cell *matCellDef="let articolo"> {{articolo.Prezzo | number: '1.2-2' }} </td>
          </ng-container>

          <ng-container matColumnDef="Note">
              <th [style.display]="getConfigurazione().Note" mat-header-cell *matHeaderCellDef>Note
                <img src="./assets/images/sort.png" (click)="manageClick('Note')"/>
              </th>
              <td [style.display]="getConfigurazione().Note" mat-cell *matCellDef="let articolo"> {{articolo.Note}} </td>
          </ng-container>

          <ng-container matColumnDef="Giacenza">
              <th [style.display]="getConfigurazione().Giacenza" mat-header-cell *matHeaderCellDef>Giacenza
                <img src="./assets/images/sort.png" (click)="manageClick('Giacenza')"/>
              </th>
              <td [style.display]="getConfigurazione().Giacenza" mat-cell *matCellDef="let articolo"> {{articolo.Giacenza | number: '1.2-2' }} </td>
          </ng-container>

          <ng-container matColumnDef="Unitamisura">
              <th [style.display]="getConfigurazione().Unitamisura" mat-header-cell *matHeaderCellDef>Unita di misura
                <img src="./assets/images/sort.png" (click)="manageClick('Unitamisura')"/>
              </th>
              <td [style.display]="getConfigurazione().Unitamisura" mat-cell *matCellDef="let articolo"> {{articolo.Unitamisura}} </td>
          </ng-container>

            <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef> Modifica </th>
                <td mat-cell *matCellDef="let articolo">
                  <mat-icon color="primary" (click)="edit(articolo)">create</mat-icon>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <br>

          <table *ngIf="totalPages>0">
            <tr>
              <td>
                <button (click)="goPrevPage()">
                  <mat-icon color="primary">keyboard_arrow_left</mat-icon>
                </button>
              </td>
              <td>
                <span class="text-sm" style="font-family:Roboto"> {{currentPage}} di {{totalPages}} </span>
              </td>
              <td>
                <button (click)="goNextPage()">
                    <mat-icon color="primary">keyboard_arrow_right</mat-icon>
                </button>
              </td>
            </tr>
          </table>
    </mat-card-content>
      <mat-card-actions>
        <table>
          <tr>
            <td>
              <button mat-raised-button  color="primary" (click)="new()">Nuovo articolo</button>
            </td>
            <td>
              <button mat-raised-button  color="primary" (click)="cancel(); fgte.value=''; flte.value=''">Cancella</button>
            </td>
          </tr>
        </table>
      </mat-card-actions>

      </mat-card>
</div>
<div [class]="tab" *ngIf="tab == 'tabTwo'">
</div>
-->
